import * as React from "react";
import ListEndorsement from "./ListEndorsement";
import SearchInputs from "./SearchInputs";
import { componentIds } from "./utils";
import { ReactiveBase, ReactiveList } from "@appbaseio/reactivesearch";

var GeneralListEndorsements = function GeneralListEndorsements(props) {
  var endorsement_types = props.endorsement_types;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "poliza_endorsements",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, /*#__PURE__*/React.createElement(SearchInputs, null)), /*#__PURE__*/React.createElement(ReactiveList, {
    componentId: "EndorsementList" //highlight
    ,
    dataField: "updated_at",
    pagination: true,
    size: 50,
    loader: "Cargando resultados...",
    sortBy: "desc",
    showResultStats: true,
    react: {
      and: componentIds()
    },
    render: function render(_ref) {
      var data = _ref.data;
      return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
        style: {
          overflow: "auto"
        }
      }, data.id, /*#__PURE__*/React.createElement(ListEndorsement, {
        endorsements: data,
        endorsement_types: endorsement_types
      }));
    }
  })));
};

export default GeneralListEndorsements;